import apiService from '@/services/apiService';

const actions = {
  getBannerMicroisites({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('microsite-banner/find-with-paging', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getGuestBook({ commit }, payload) {
    apiService.get(`microsite-guestbook`)
      .then((response) => {
        commit('getGuestBook', response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  postGuestBook({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('microsite-guestbook', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  putBannerMicroisites({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`microsite-banner/${payload.id}`, payload.formData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  orderBannerMicroisites({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`microsite-banner/${payload.id}/change-order`, payload.orderData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  delBannerMicroisites({ commit }, payload) {
    apiService.delete(`microsite-banner/${payload}`)
      .then((response) => {
        console.log(response);
      })
      .catch((error) => {
        console.log(error);
      });
  },

};

export default actions;
